var WISHLIST_KEY = 'wishlist';

function wlGetList() {
  try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
  catch (e) { return []; }
}

function wlSaveList(items) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
}

function wlIsInList(url) {
  return wlGetList().some(function(item) { return item.productUrl === url; });
}

function wlEscapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function wlStripHtml(str) {
  var tmp = document.createElement('div');
  tmp.innerHTML = str;
  return tmp.textContent || tmp.innerText || '';
}

/* ---- Header badge ---- */
function updateWishlistBadge() {
  var badge = document.getElementById('wlHeaderCount');
  if (!badge) return;
  var count = wlGetList().length;
  badge.textContent = count > 0 ? count : '';
  badge.classList.toggle('has-items', count > 0);
}

/* ---- Toast ---- */
function showToast(msg, type) {
  var container = document.getElementById('wl-toast-container');
  if (!container) {
    container = document.createElement('div');
    container.id = 'wl-toast-container';
    document.body.appendChild(container);
  }
  var t = document.createElement('div');
  t.className = 'wl-toast wl-toast--' + (type || 'info');
  t.textContent = msg;
  container.appendChild(t);
  setTimeout(function() {
    t.style.opacity = '0';
    t.style.transform = 'translateY(8px)';
    setTimeout(function() { if (t.parentNode) t.parentNode.removeChild(t); }, 300);
  }, 3000);
}

/* ---- PDP wishlist button ---- */
function toggleWishlist(btn) {
  var url = btn.dataset.productUrl;
  var list = wlGetList();
  var idx = -1;
  for (var i = 0; i < list.length; i++) {
    if (list[i].productUrl === url) { idx = i; break; }
  }
  if (idx >= 0) {
    list.splice(idx, 1);
    showToast('Removed from wishlist', 'info');
  } else {
    list.push({
      productTitle: btn.dataset.productTitle,
      productImg:   btn.dataset.productImg,
      productPrice: btn.dataset.productPrice,
      productUrl:   url,
      variantId:    btn.dataset.variantId || ''
    });
    showToast('Added to wishlist!', 'success');
  }
  wlSaveList(list);
  updateWishlistButton(btn);
  updateWishlistBadge();
}

function updateWishlistButton(btn) {
  var inList = wlIsInList(btn.dataset.productUrl);
  btn.classList.toggle('is-wishlisted', inList);
  btn.setAttribute('aria-label', inList ? 'Remove from wishlist' : 'Add to wishlist');
  var outline = btn.querySelector('.wl-heart-outline');
  var filled  = btn.querySelector('.wl-heart-filled');
  var label   = btn.querySelector('.wl-btn-label');
  if (outline) outline.style.display = inList ? 'none' : 'block';
  if (filled)  filled.style.display  = inList ? 'block' : 'none';
  if (label)   label.textContent     = inList ? 'Remove from Wishlist' : 'Add to Wishlist';
}

/* ---- Wishlist page renderer ---- */
function wlExtractHandle(url) {
  var m = url.match(/\/products\/([^?#/]+)/);
  return m ? m[1] : null;
}

function displayWishlist() {
  var block = document.querySelector('.js-wishlistBlock');
  if (!block) return;
  var list = wlGetList();
  if (!list.length) {
    block.innerHTML = '<div class="wl-empty"><p>Your wishlist is empty.</p><a href="/" class="wl-empty__link">Start shopping</a></div>';
    return;
  }

  var html = '';
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    html += '<div class="wl-page-card">'
      + '<div class="wl-page-card__img-wrap">'
      +   '<a href="' + wlEscapeHtml(item.productUrl) + '">'
      +     '<img src="' + wlEscapeHtml(item.productImg) + '" alt="' + wlEscapeHtml(item.productTitle) + '" loading="lazy" width="370" height="490">'
      +   '</a>'
      +   '<button class="plp-wl-btn is-wishlisted" type="button" aria-label="Remove from wishlist"'
      +     ' data-url="' + wlEscapeHtml(item.productUrl) + '" onclick="removeFromWishlist(this)">'
      +     HEART_FILLED
      +   '</button>'
      + '</div>'
      + '<div class="wl-page-card__body">'
      +   '<a href="' + wlEscapeHtml(item.productUrl) + '" class="wl-page-card__title">' + wlEscapeHtml(item.productTitle) + '</a>'
      +   '<div class="wl-page-card__price">' + wlEscapeHtml(wlStripHtml(item.productPrice)) + '</div>'
      +   '<button class="wl-page-atc-btn" id="wl-atc-' + i + '" disabled>ADD TO BAG</button>'
      + '</div>'
      + '</div>';
  }
  block.innerHTML = html;

  // Fetch each product's first available variant and activate the ATC button
  list.forEach(function(item, i) {
    var handle = wlExtractHandle(item.productUrl);
    if (!handle) return;

    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        var variant = null;
        for (var v = 0; v < product.variants.length; v++) {
          if (product.variants[v].available) { variant = product.variants[v]; break; }
        }
        if (!variant) variant = product.variants[0];
        if (!variant) return;

        var placeholder = document.getElementById('wl-atc-' + i);
        if (!placeholder) return;

        var form = document.createElement('form');
        form.action = '/cart/add';
        form.method = 'post';
        form.setAttribute('data-type', 'add-to-cart-form');
        form.noValidate = true;
        form.innerHTML =
          '<input type="hidden" name="id" value="' + variant.id + '">'
          + '<input type="hidden" name="quantity" value="1">'
          + '<button type="submit" name="add" class="wl-page-atc-btn">ADD TO BAG</button>';
        placeholder.parentNode.replaceChild(form, placeholder);
      })
      .catch(function() {
        var placeholder = document.getElementById('wl-atc-' + i);
        if (placeholder) {
          placeholder.textContent = 'VIEW PRODUCT';
          placeholder.disabled = false;
          placeholder.onclick = function() { window.location.href = item.productUrl; };
        }
      });
  });
}

function removeFromWishlist(btn) {
  var url = btn.dataset.url;
  var list = wlGetList().filter(function(item) { return item.productUrl !== url; });
  wlSaveList(list);
  showToast('Removed from wishlist', 'info');
  displayWishlist();
  updateWishlistBadge();
}

/* ---- PLP — inject custom heart buttons, replacing Wishlist Hero ---- */
var HEART_OUTLINE = '<svg class="plp-wl-icon plp-wl-outline" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#843C1F" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
var HEART_FILLED  = '<svg class="plp-wl-icon plp-wl-filled" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="#843C1F" stroke="#843C1F" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';

function initPlpWishlist() {
  document.querySelectorAll('li.products-list-item, li.product, .product-recommendations-product').forEach(function(card) {
    if (card.querySelector('.plp-wl-btn')) return;

    var imgWrap = card.querySelector('.products-list-item__image, .product__image, .product-recommendations-product__image');
    if (!imgWrap) return;

    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return;

    var productUrl   = link.getAttribute('href');
    var productTitle = link.getAttribute('title') || link.textContent.trim();

    var imgEl = imgWrap.querySelector('img[src]');
    var productImg = imgEl ? (imgEl.getAttribute('src') || '') : '';
    if (productImg.indexOf('//') === 0) productImg = 'https:' + productImg;
    if (productImg) {
      productImg = productImg.replace(/[?&]width=\d+/, '');
      productImg += (productImg.indexOf('?') >= 0 ? '&' : '?') + 'width=370';
    }

    var priceEl = card.querySelector('.price__current, .price-item--regular, .price');
    var productPrice = priceEl ? priceEl.textContent.trim().replace(/\s+/g, ' ') : '';

    var variantInput = card.querySelector('input[name="id"]');
    var variantId = variantInput ? variantInput.value : '';

    var inList = wlIsInList(productUrl);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'plp-wl-btn' + (inList ? ' is-wishlisted' : '');
    btn.setAttribute('aria-label', inList ? 'Remove from wishlist' : 'Add to wishlist');
    btn.dataset.productUrl   = productUrl;
    btn.dataset.productTitle = productTitle;
    btn.dataset.productImg   = productImg;
    btn.dataset.productPrice = productPrice;
    btn.dataset.variantId    = variantId;
    btn.innerHTML = HEART_OUTLINE + HEART_FILLED;

    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      plpToggleWishlist(btn);
    });

    imgWrap.appendChild(btn);
  });
}

function plpToggleWishlist(btn) {
  var url  = btn.dataset.productUrl;
  var list = wlGetList();
  var idx  = -1;
  for (var i = 0; i < list.length; i++) {
    if (list[i].productUrl === url) { idx = i; break; }
  }
  if (idx >= 0) {
    list.splice(idx, 1);
    wlSaveList(list);
    btn.classList.remove('is-wishlisted');
    btn.setAttribute('aria-label', 'Add to wishlist');
    showToast('Removed from wishlist', 'info');
  } else {
    list.push({
      productTitle: btn.dataset.productTitle,
      productImg:   btn.dataset.productImg,
      productPrice: btn.dataset.productPrice,
      productUrl:   url,
      variantId:    btn.dataset.variantId || ''
    });
    wlSaveList(list);
    btn.classList.add('is-wishlisted');
    btn.setAttribute('aria-label', 'Remove from wishlist');
    showToast('Added to wishlist!', 'success');
  }
  updateWishlistBadge();
}

document.addEventListener('DOMContentLoaded', function() {
  // PDP heart button (title area)
  var pdpBtn = document.querySelector('.pdp-title-wishlist');
  if (pdpBtn) {
    updateWishlistButton(pdpBtn);
    pdpBtn.addEventListener('click', function() { toggleWishlist(pdpBtn); });
  }

  // Wishlist page
  displayWishlist();

  // Header badge — sync on every page load from localStorage
  updateWishlistBadge();

  // PLP + recommendation cards (initial pass)
  initPlpWishlist();

  // Re-run when async sections (e.g. "You may also like") inject cards into the DOM
  var wlObserver = new MutationObserver(function(mutations) {
    var needsInit = false;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (
          node.matches('li.products-list-item, li.product, .product-recommendations-product') ||
          node.querySelector('li.products-list-item, li.product, .product-recommendations-product, .product__image, .product-recommendations-product__image')
        ) {
          needsInit = true;
          break;
        }
      }
      if (needsInit) break;
    }
    if (needsInit) initPlpWishlist();
  });

  wlObserver.observe(document.body, { childList: true, subtree: true });
});
